<template>
  <AuthLayout :mode="mode">
    <ContactActions type="add" :mode="mode" />
  </AuthLayout>
</template>

<script>
import ContactActions from "@C/ContactActions.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "AddContactSettings",
  components: {
    AuthLayout,
    ContactActions,
  },
  props: {
    mode: String,
  },
};
</script>
